import React, { useEffect, useState } from 'react';
import "../../css/Faq/FaqScreen.css";
import { FiChevronDown } from "react-icons/fi";

const FaqComponent = () => {
  const [getFaqData, setGetFaqData] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const fetchFaqs = async () => {
    const tokenData = localStorage.getItem("auth-token");
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/data/faqs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ tokenData })
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      console.error('Fetch FAQs Error:', errorDetails);
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    setGetFaqData(data);
    return data;
  };

  useEffect(() => {
    fetchFaqs().catch(error => console.error('useEffect fetchFaqs Error:', error));
  }, []);

  const renderQuestions = () => {
    return getFaqData.map((faq, index) => (
      <div
        key={index}
        className="question-container"
        onClick={() => setSelectedQuestion(selectedQuestion === index ? null : index)}
      >
        <div className="question-text-container">
          <span className="question">{faq.nyc_name}</span>
          <FiChevronDown
            className={`icon ${selectedQuestion === index ? "rotated" : ""}`}
          />
        </div>
        {selectedQuestion === index && (
          <div className="answer">{faq.nyc_answer}</div>
        )}
      </div>
    ));
  };

  return (
    <div className="main-screen">
  <div style={{ display: 'flex', position: 'relative', height: '100vh' }}>
    {/* Icon Container */}
    <div
      style={{
        position: 'absolute',
        top: '50%', // Position the icon container in the middle of the screen
        left: '0',
        transform: 'translateY(-50%)', // Center the icon vertically
        width: '10vw', // Reduce the size of the icon container
        height: '10vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Overlapping Question Marks */}
      <div
        style={{
          position: 'absolute',
          borderRadius: '50%',
          border: '0.2vw solid #DC0A0A', // Reduce border size
          width: '8vw', // Reduce size of the first question mark
          height: '8vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#000000',
          fontSize: '5vw', // Reduce font size of the question mark
          fontWeight: 'bold',
          zIndex: 1,
        }}
      >
        ?
      </div>
      <div
        style={{
          position: 'absolute',
          borderRadius: '50%',
          border: '0.2vw solid #000000', // Reduce border size
          width: '8vw', // Reduce size of the second question mark
          height: '8vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#DC0A0A',
          fontSize: '5vw', // Reduce font size of the question mark
          fontWeight: 'bold',
          top: '2vw', // Adjust overlap position
          left: '2vw',
          zIndex: 0,
        }}
      >
        ?
      </div>
    </div>

    {/* FAQ Section */}
    <div style={{ flex: 1, paddingLeft: '10px', marginTop: '20px' }}>
      <div className="faq-title-container">
        <span className="title">Frequently Asked Questions</span>
      </div>
      <div className="container">
        <div className="scroll-container">
          {renderQuestions()}
        </div>
      </div>
    </div>
  </div>
</div>

  );
};

export default FaqComponent;
